<script>
export default {
  name: 'has-filters',
  data () {
    if (this.$options.hasDateRangeFilter) {
      return {
        initialFilterValues: Object.assign({
          search: '',
          dateRange: {
            startDate: null,
            endDate: null
          }
        }, this.$options.additionalFilters),
        filters: Object.assign({
          search: '',
          dateRange: {
            startDate: null,
            endDate: null
          }
        }, this.$options.additionalFilters)
      };
    }

    return {
      initialFilterValues: Object.assign({
        search: ''
      }, this.$options.additionalFilters),
      filters: Object.assign({
        search: ''
      }, this.$options.additionalFilters)
    };
  },
  beforeMount () {
    this.initialFilterValues = JSON.parse(JSON.stringify(this.filters));
    this.loadFilters();
  },
  mounted () {
    this.$bus.$on('view-filters-save', this.saveFilters);
    this.$bus.$on('view-filters-reset', this.resetFilters);
  },
  methods: {
    loadFilters () {
      if (!localStorage.getItem('pet-fish-crm-filters')) {
        this.resetFilters();
        return;
      }

      let filtersData = JSON.parse(localStorage.getItem('pet-fish-crm-filters'));

      if (filtersData.view && filtersData.view === this.$options.name) {
        this.filters = JSON.parse(JSON.stringify(filtersData.filters));
      } else {
        this.resetFilters();
      }
    },
    saveFilters () {
      let filtersData = {
        view: this.$options.name,
        filters: this.filters
      };
      filtersData = JSON.stringify(filtersData);
      localStorage.setItem('pet-fish-crm-filters', filtersData);
      this.debouncedLoadFilteredData();
    },
    resetFilters () {
      this.filters = JSON.parse(JSON.stringify(this.initialFilterValues));
      this.saveFilters();
    }
  },
  beforeDestroy () {
    this.$bus.$off('view-filters-save', this.saveFilters);
    this.$bus.$off('view-filters-reset', this.saveFilters);
  }
}
</script>
